module.exports = __webpack_public_path__ + "static/media/bi.82121bd1.png";